// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebDisableSubscriptionRequest,
  TWebDisableSubscriptionModel,
  IMappers,
  TWebDisableSubscriptionResponse,
  TWebDisableSubscriptionResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebDisableSubscriptionModel(
  parameters: TWebDisableSubscriptionRequest,
): TWebDisableSubscriptionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'saved-searches',
    pathApi: '/v1/web/disable-subscription/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebDisableSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebDisableSubscriptionRequest;
}

export async function fetchWebDisableSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebDisableSubscriptionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebDisableSubscriptionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebDisableSubscriptionModel(parameters),
    config,
  )) as FetchResponse<TWebDisableSubscriptionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TWebDisableSubscriptionResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebDisableSubscriptionResponse>;
}
